// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___E7OyJ","root__wrapper":"style-module__root__wrapper___W_lED"};
    if(module.hot) {
      // 1697460474214
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  